import { sumBy } from 'lodash';

const calculateColumnResult = (firstSection, middleSection, lastSection) => {
	const firstSectionResult = sumBy(firstSection, 'value');
	const finalFirstSectionResult = firstSectionResult >= 60 ? firstSectionResult + 30 : firstSectionResult;
	const middleSectionResult = (middleSection[0].value - middleSection[1].value) * firstSection[0].value;
	const lastSectionResult = sumBy(lastSection, 'value');
	return { firstSectionResult: finalFirstSectionResult, middleSectionResult, lastSectionResult };
};

export default calculateColumnResult;
